import React from 'react';
import { Typography, Chip, Grid2, Box } from '@mui/material';
import skills from '../Data/SkillsData';
const Skills = () => (
    <React.Fragment>
        {skills.map((group) => (
            <div key={group.category}>
                <Box sx={{ borderLeft: 4, borderColor: 'primary.main', pl: 1, mb: 1 }}>
                    <Typography variant="subtitle2" fontWeight="bold">
                        {group.category}
                    </Typography>
                </Box>
                <Grid2 container spacing={1} sx={{ mb: 2 }}>
                    {group.skills.map((skill) => (
                        <Grid2 item="true" key={skill.name}>
                            <Chip
                                label={skill.name}
                                icon={skill.icon}
                                color="primary.main"
                                variant="outlined"
                                sx={{ fontSize: '0.875rem' }}
                            />
                        </Grid2>
                    ))}
                </Grid2>
            </div>
        ))}
    </React.Fragment>
);

export default Skills;
